module.exports = __webpack_public_path__ + "media/application/images/brand/logo--horizontal-83c29c7830e200e8c8b3dbdabc2d2d02.png";